import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as _ from 'lodash';
import { ContentCardWrap } from 'components';
import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';
import Dialog from 'material-ui/Dialog';
import Measure from 'react-measure';
import RaisedButton from 'material-ui/RaisedButton';
import { getFavorites } from 'redux/modules/contentLibrary';
import { deleteAccountFromTag, favoriteChannel, subscribeAccountsToTag, unFavoriteChannel } from 'redux/modules/contentLibrary';
import { getSocialAccounts } from 'redux/modules/organization';
import { LLSocialAccountChip } from 'components/FormElements';
import { QueueWrap } from 'components';
import { connect } from 'react-redux';
import xLogo from '../../assets/x-logo-white.png';
var ContentQueueControl = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    addingSAInProgress: state.contentLibrary.addingSAInProgress,
    deletingAccountLink: state.contentLibrary.deletingAccountLink,
    favorites: state.contentLibrary[orgId] && state.contentLibrary[orgId].favorites ? state.contentLibrary[orgId].favorites : [],
    organization: state.organization.current,
    categoryContent: state.contentLibraryContent.categoryContent,
    loadingCategoryContent: state.contentLibraryContent.loadingCategoryContent,
    socialAccounts: state.organization.current.SocialAccounts
  };
}, {
  deleteAccountFromTag: deleteAccountFromTag,
  favoriteChannel: favoriteChannel,
  subscribeAccountsToTag: subscribeAccountsToTag,
  unFavoriteChannel: unFavoriteChannel,
  getSocialAccounts: getSocialAccounts,
  getFavorites: getFavorites
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentQueueControl, _Component);

  var _super = _createSuper(ContentQueueControl);

  function ContentQueueControl(props) {
    var _this;

    _classCallCheck(this, ContentQueueControl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "deleteQueueFromChannel", function (queue) {
      _this.props.deleteAccountFromTag(_this.props.organization.id, [queue.SocialAccounts[0].id], _this.props.category.id, queue).then(function () {
        _this.setState({
          openDialogSocialAccountId: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitSocialAccountSubscriptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var socialAccountIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              socialAccountIds = _this.state.addOverlaySelectedQueues.map(function (idStr) {
                var targetId = "".concat(idStr).split(':').pop();

                if (idStr.indexOf('queue:') === 0) {
                  return _this.props.category.OtherQueues.find(function (q) {
                    return "".concat(q.id) === targetId;
                  }).SocialAccounts[0].id;
                }

                return _this.props.socialAccounts.find(function (sa) {
                  return "".concat(sa.id) === targetId;
                }).id;
              });
              console.log(socialAccountIds);

              _this.setState({
                addOverlaySelectedQueues: [],
                showAddAccountDialog: false
              });

              _context.next = 6;
              return _this.props.subscribeAccountsToTag(_this.props.organization.id, socialAccountIds, _this.props.category.id, _this.state.addOverlaySelectedQueues);

            case 6:
              _context.next = 8;
              return _this.props.getFavorites(_this.props.organization.id);

            case 8:
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderAddAccountDialog", function () {
      var _this$props$category = _this.props.category,
          availableQueues = _this$props$category.OtherQueues,
          connectedQueues = _this$props$category.Queues;

      var handleAccountQueueOnClick = function handleAccountQueueOnClick() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'queue';
        var targetObj = arguments.length > 1 ? arguments[1] : undefined;
        return function () {
          var currentlySelectedQueueIds = _toConsumableArray(_this.state.addOverlaySelectedQueues).map(function (q) {
            return q.id;
          });

          if (currentlySelectedQueueIds.includes("".concat(type, ":").concat(targetObj.id))) {
            _this.setState({
              addOverlaySelectedQueues: _this.state.addOverlaySelectedQueues.filter(function (oq) {
                return "".concat(type, ":").concat(targetObj.id) !== "".concat(oq);
              })
            });
          } else {
            _this.setState({
              addOverlaySelectedQueues: [].concat(_toConsumableArray(_this.state.addOverlaySelectedQueues), ["".concat(type, ":").concat(targetObj.id)])
            });
          }
        };
      };

      var isChipSelected = function isChipSelected(idStr) {
        return _toConsumableArray(_this.state.addOverlaySelectedQueues).indexOf(idStr) !== -1;
      };

      var unselectedChips = availableQueues.map(function (queue) {
        return /*#__PURE__*/React.createElement(LLSocialAccountChip, {
          key: "q_".concat(queue.id),
          socialAccount: queue.SocialAccounts[0],
          style: {
            "float": 'left',
            margin: '3px',
            opacity: isChipSelected("queue:".concat(queue.id)) ? 1 : 0.5,
            cursor: 'pointer'
          },
          onClick: handleAccountQueueOnClick('queue', queue)
        });
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#616161'
        }
      }, unselectedChips.length > 0 ? "Pick a queue from the list below to add ".concat(_this.props.category.tagName, " content to that queue.") : availableQueues.length === 0 && connectedQueues.length === 0 ? 'You do not have any available queues.' : 'This Content Category is connected to all of your available queues.'), !!unselectedChips.length && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, unselectedChips)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderQueueDialogLabel", function () {
      var queue = _this.state.clickedQueueChip;
      var network = ''; // Wrapping in a try catch just in case we end up with a queue without any social networks

      try {
        network = queue.SocialAccounts[0].platform.split(' ')[0].toLowerCase();
      } catch (e) {
        network = null;
      }

      var labelText = queue.SocialAccounts[0] && queue.SocialAccounts[0].username ? _.startCase(queue.SocialAccounts[0].username) : '';
      return !network ? 'Queue' : /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          marginRight: 12,
          fontSize: 20
        },
        className: "fa fa-".concat(network)
      }), " ", "".concat(labelText, " Queue"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSocialAccountIcon", function (sa) {
      var style = {
        fontSize: 18,
        margin: '9.4px'
      };

      if (sa.platform.indexOf('Facebook') === 0) {
        return /*#__PURE__*/React.createElement("i", {
          className: 'fa fa-facebook',
          style: style
        });
      } else if (sa.platform.indexOf('LinkedIn') === 0) {
        return /*#__PURE__*/React.createElement("i", {
          className: 'fa fa-linkedin ',
          style: style
        });
      } else if (sa.platform === 'Twitter') {
        return /*#__PURE__*/React.createElement("img", {
          src: xLogo,
          style: style
        });
      } else if (sa.platform === 'Google my business') {
        return /*#__PURE__*/React.createElement("i", {
          className: 'fa fa-google ',
          style: style
        });
      }

      return /*#__PURE__*/React.createElement("i", {
        className: 'fa fa-instagram ',
        style: style
      });
    });

    _this.state = {
      clickedQueueChip: null,
      queueModalHeight: 300,
      showAddAccountDialog: false,
      showQueueWrap: false,
      addOverlaySelectedQueues: [],
      showNewQueueModal: false
    };
    return _this;
  }

  _createClass(ContentQueueControl, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.props.getSocialAccounts(this.props.organization.id);

              case 3:
                _context2.next = 7;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var category = this.props.category;
      var usedQueues = category.Queues;
      var availableQueues = category.OtherQueues;
      var addAccountActions = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          return _this2.setState({
            showAddAccountDialog: false
          });
        },
        style: {
          marginRight: 24
        },
        disabled: this.props.addingSAInProgress
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.props.addingSAInProgress ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Add',
        onClick: this.submitSocialAccountSubscriptions,
        disabled: this.props.addingSAInProgress || !this.state.addOverlaySelectedQueues || this.state.addOverlaySelectedQueues.length === 0
      })];
      return /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['height'],
        onMeasure: function onMeasure(dimensions) {
          _this2.props.handleQueueRowHeightChange(dimensions.height);
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          marginBottom: 12
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#616161',
          fontSize: 14,
          marginRight: 8,
          marginBottom: 12
        }
      }, "Queues:"), (!usedQueues || !!usedQueues && usedQueues.length === 0) && false && /*#__PURE__*/React.createElement("i", {
        onClick: function onClick() {
          return _this2.setState({
            showNewQueueModal: true
          });
        },
        style: {
          color: '#8b8b8b',
          cursor: 'pointer',
          display: 'inline-block',
          fontSize: 24,
          marginBottom: 12
        },
        className: 'ion-ios-plus icon'
      }), usedQueues && !!usedQueues.length && usedQueues.map(function (q, index) {
        if (q.SocialAccounts && q.SocialAccounts.length) {
          var sa = q.SocialAccounts[0];
          var removeAccountActions = [/*#__PURE__*/React.createElement(RaisedButton, {
            label: "Cancel",
            onClick: function onClick() {
              return _this2.setState({
                openDialogSocialAccountId: null
              });
            },
            key: "".concat(sa.id, "_0"),
            style: {
              margin: 8,
              marginTop: 24
            },
            disabled: _this2.props.unfavoriting
          }), /*#__PURE__*/React.createElement(RaisedButton, {
            secondary: true,
            disabled: _this2.props.deletingAccountLink || _this2.props.addingSAInProgress,
            label: _this2.props.deletingAccountLink ? /*#__PURE__*/React.createElement("i", {
              className: "fa fa-spin fa-spinner",
              style: {
                fontSize: 20
              }
            }) : 'Remove',
            onClick: function onClick() {
              _this2.deleteQueueFromChannel(q);
            },
            key: "".concat(sa.id, "_1"),
            style: {
              margin: 8,
              marginTop: 24
            }
          })];
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'flex',
              flexDirection: 'row-reverse',
              alignItems: 'center',
              marginRight: 12,
              marginBottom: 12
            }
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              background: 'rgb(223,223,223)',
              borderRadius: '0 16px 16px 0',
              height: 32,
              lineHeight: '32px',
              paddingLeft: 18,
              paddingRight: 8,
              position: 'relative',
              left: -13
            }
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              backgroundColor: 'rgb(139,139,139)',
              color: 'rgb(223,223,223)',
              display: 'inline-block',
              fontSize: 19,
              height: 20,
              borderRadius: '50%',
              cursor: 'pointer',
              width: 20,
              lineHeight: '20px',
              textAlign: 'center'
            },
            onClick: function onClick(e) {
              _this2.setState({
                openDialogSocialAccountId: sa.id
              });
            }
          }, "\xD7")), /*#__PURE__*/React.createElement(Chip, {
            key: "queueChip_".concat(index, "_").concat(q.id),
            style: {
              cursor: 'pointer'
            },
            socialAccount: q.SocialAccounts[0],
            onClick: function onClick(e) {
              _this2.setState({
                showQueueWrap: true,
                clickedQueueChip: q
              });
            }
          }, /*#__PURE__*/React.createElement(Avatar, {
            icon: sa && _this2.renderSocialAccountIcon(sa),
            color: "white",
            backgroundColor: "rgb(139,139,139)"
          }), sa && sa.username)), /*#__PURE__*/React.createElement(Dialog, {
            actions: removeAccountActions,
            open: _this2.state.openDialogSocialAccountId === sa.id,
            title: "Remove All ".concat(_this2.props.category.tagName, " Content?")
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
            style: {
              color: '#616161'
            }
          }, "This will remove ".concat(_this2.props.category.tagName, " content from your ").concat(sa.username, " queue and also\n                      suspend the addition of new pieces of content.")), /*#__PURE__*/React.createElement("p", {
            style: {
              color: '#616161'
            }
          }, "You can still select individual pieces of content from the ", _this2.props.category.tagName, ' ', "content library and schedule it."))), /*#__PURE__*/React.createElement(Dialog, {
            style: {
              height: _this2.state.queueModalHeight
            },
            open: _this2.state.showQueueWrap,
            onRequestClose: function onRequestClose() {
              _this2.setState({
                clickedQueueChip: null,
                showQueueWrap: false
              });
            },
            autoScrollBodyContent: true,
            title: _this2.state.clickedQueueChip ? _this2.renderQueueDialogLabel() : ''
          }, /*#__PURE__*/React.createElement(Measure, {
            onMeasure: function onMeasure(dimensions) {
              _this2.setState({
                queueModalHeight: dimensions.height
              });
            },
            whitelist: ['width', 'height'],
            useClone: true
          }, /*#__PURE__*/React.createElement(QueueWrap, {
            showTabs: false,
            selectedQueue: _this2.props.queues && !!_this2.props.queues.length ? _this2.props.queues.findIndex(function (q) {
              return parseInt(q.id) === parseInt(_this2.state.clickedQueueChip.id);
            }) : null
          }))));
        }
      }), !this.props.deletingAccountLink && /*#__PURE__*/React.createElement("i", {
        onClick: function onClick() {
          return _this2.setState({
            showAddAccountDialog: true
          });
        },
        style: {
          color: '#8b8b8b',
          cursor: 'pointer',
          display: 'inline-block',
          fontSize: 24,
          marginBottom: 12
        },
        className: 'ion-ios-plus icon'
      }), /*#__PURE__*/React.createElement(Dialog, {
        actions: addAccountActions,
        open: this.state.showAddAccountDialog,
        title: "Add Content To Your Queue"
      }, this.renderAddAccountDialog()), /*#__PURE__*/React.createElement(Dialog, {
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          label: "Cancel",
          onClick: function onClick() {
            return _this2.setState({
              showNewQueueModal: null
            });
          }
        })],
        open: this.state.showNewQueueModal,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            showNewQueueModal: false
          });
        },
        autoScrollBodyContent: true,
        title: 'Create Content Queue',
        bodyStyle: {
          padding: 20
        }
      }, /*#__PURE__*/React.createElement("h3", null, "Which Social Account will this Queue post to?"), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, this.props.socialAccounts ? this.props.socialAccounts.length > 0 ? this.props.socialAccounts.map(function (sa) {
        return /*#__PURE__*/React.createElement(LLSocialAccountChip, {
          key: "".concat(sa.id, "_newqueuechip"),
          style: {
            cursor: 'pointer',
            marginRight: 12,
            marginBottom: 12
          },
          socialAccount: sa,
          onClick: function onClick() {}
        });
      }) : 'You must first connect a social account in settings.' : null))));
    }
  }]);

  return ContentQueueControl;
}(Component)) || _class);
ContentQueueControl.defaultProps = {};
export default ContentQueueControl;